'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * POST designmanager/v1/widgets
 *
 * @param  {Object} widget  Object containing widget properties.
 */

export function create(widget) {
  return http.post('designmanager/v1/widgets', {
    data: widget
  });
}
/**
 * GET designmanager/v1/widgets/:widgetId
 */

export function fetch(widgetId) {
  return http.get(`designmanager/v1/widgets/${widgetId}`);
}
/**
 * GET designmanager/v1/widgets?:query
 */

export function fetchQuery(query = {}) {
  return http.get('designmanager/v1/widgets', {
    query
  });
}
/**
 * GET  designmanager/v1/widgets
 */

export function fetchSummaries(query = {}) {
  return fetchQuery(query);
}
/**
 * PUT designmanager/v1/widgets/:widgetId
 */

export function publish(widgetId, data) {
  return http.put(`designmanager/v1/widgets/${widgetId}`, {
    data,
    timeout: 15000
  });
}
/**
 * Proxy to publish to work with finder
 */

export function save(widgetId, data) {
  return publish(widgetId, data);
}
/**
 * DELETE designmanager/v1/widgets/:widgetId
 */

export function del(widgetId) {
  return http.delete(`designmanager/v1/widgets/${widgetId}`);
}
/**
 * DELETE designmanager/v1/widgets/bulk?:widgetIds
 */

export function bulkDelete(widgetIds) {
  return http.delete('designmanager/v1/widgets/bulk', {
    query: {
      id: widgetIds
    }
  });
}
/**
 * POST  designmanager/v1/modules/:widgetId/upgrade-global
 */

export function upgrade(widgetId) {
  return http.post(`designmanager/v1/modules/${widgetId}/upgrade-global`);
}
/**
 * PUT designmanager/v1/widgets/:widgetId/restore-deleted
 */

export function restoreDeleted(widgetId) {
  return http.put(`designmanager/v1/widgets/${widgetId}/restore-deleted`);
}